import {
  TemplateLayoutConfig,
  OfferTemplateConfig,
  DEFAULT_TEMPLATE_CONFIG,
  CoverPageSettings,
  OfferPageSettings,
  ContentPageSettings,
  GreetingBlockSettings,
  CustomerInfoBlockSettings,
  ItemsTableBlockSettings,
  TotalsBlockSettings,
  TermsBlockSettings,
  BankAccountsBlockSettings,
  FooterBlockSettings,
  SignatureBlockSettings,
  HeadingBlockSettings,
  ParagraphBlockSettings,
  QuoteBlockSettings,
  StatGridBlockSettings,
  ServiceGridBlockSettings,
} from '../../../types/offerTemplate.types';

export interface TemplatePreset {
  id: string;
  name: string;
  description: string;
  config: Partial<OfferTemplateConfig>;
  layout: TemplateLayoutConfig;
}

// ============================================================================
// KURUMSAL PRESET (SIBLY HOTEL benzeri: kapak + tanıtım sayfaları + teklif)
// ============================================================================

const KURUMSAL_LAYOUT: TemplateLayoutConfig = {
  pages: [
    {
      id: 'p-cover', type: 'coverPage', visible: true, order: 0, title: 'Kapak',
      settings: {
        titleText: 'Proje\nTeklifi',
        subtitleText: 'Akıllı ve Yönetilebilir Sistemler',
        showDecorCircles: true,
        bgGradient: true,
        preparedBy: { name: 'Genel Müdür', email: 'info@firma.com', web: 'www.firma.com', title: '' },
      } as CoverPageSettings,
    },
    {
      id: 'p-intro', type: 'contentPage', visible: true, order: 1, title: 'Giriş',
      settings: { bgColor: '#ffffff' } as ContentPageSettings,
      blocks: [
        { id: 'b-q1', type: 'quote', visible: true, order: 0, settings: { text: 'İşletmelere yenilikçi ve etkili çözümler sunarak başarıya ulaşmalarına yardımcı oluyoruz.', fontSize: 18 } as QuoteBlockSettings },
        { id: 'b-h1', type: 'heading', visible: true, order: 1, settings: { text: 'Giriş', fontSize: 28, align: 'left' } as HeadingBlockSettings },
        { id: 'b-p1', type: 'paragraph', visible: true, order: 2, settings: { text: 'Firmamız uluslararası düzeyde kabul görmüş standartlarda profesyonel proje yönetim uzmanlarına ve deneyimine sahiptir. Bu sayede gerek planlama, gerek uygulama ve gerekse kontrol ve sonlandırma aşamalarında ihtiyaç duyulan tüm işleri başarıyla yapabilecek düzeydedir.', fontSize: 14, align: 'left' } as ParagraphBlockSettings },
      ],
    },
    {
      id: 'p-about', type: 'contentPage', visible: true, order: 2, title: 'Biz Kimiz',
      settings: { bgColor: '#ffffff' } as ContentPageSettings,
      blocks: [
        { id: 'b-h2', type: 'heading', visible: true, order: 0, settings: { text: 'Biz Kimiz?', fontSize: 28, align: 'left' } as HeadingBlockSettings },
        { id: 'b-p2', type: 'paragraph', visible: true, order: 1, settings: { text: 'Firmamız sektörde uzun yılların deneyimiyle hizmet vermektedir. Yenilikçi çözümler ve kaliteli hizmet anlayışıyla müşterilerimizin güvenini kazanmaktayız.', fontSize: 14, align: 'left' } as ParagraphBlockSettings },
        { id: 'b-sg1', type: 'statGrid', visible: true, order: 2, settings: { items: [{ value: '2007', label: 'Kuruluş' }, { value: '3200+', label: 'Mutlu Müşteri' }, { value: '40+', label: 'Çalışan' }, { value: '5+', label: 'Ofis' }], columns: 4 } as StatGridBlockSettings },
      ],
    },
    {
      id: 'p-services', type: 'contentPage', visible: true, order: 3, title: 'Hizmetlerimiz',
      settings: { bgColor: '#ffffff' } as ContentPageSettings,
      blocks: [
        { id: 'b-h3', type: 'heading', visible: true, order: 0, settings: { text: 'Hizmetlerimiz', fontSize: 28, align: 'left' } as HeadingBlockSettings },
        { id: 'b-srv1', type: 'serviceGrid', visible: true, order: 1, settings: { items: [{ title: 'Altyapı Hizmetleri' }, { title: 'Yazılım Geliştirme' }, { title: 'Danışmanlık' }, { title: 'Proje Yönetimi' }, { title: 'Teknik Destek' }, { title: 'Bakım Hizmetleri' }], columns: 3 } as ServiceGridBlockSettings },
      ],
    },
    {
      id: 'p-offer', type: 'offerPage', visible: true, order: 4, title: 'Teklif',
      settings: { showGreeting: true } as OfferPageSettings,
      blocks: [
        { id: 'b-greet', type: 'greeting', visible: true, order: 0, settings: { text: 'Sunduğumuz çözüm ve hizmetlere ilişkin fiyat, stok ve diğer koşulları teklifimizde bilgilerinize sunuyoruz.', showDate: true } as GreetingBlockSettings },
        { id: 'b-cust', type: 'customerInfo', visible: true, order: 1, settings: { borderStyle: 'left-accent', showTaxInfo: true, showAddress: true, showPhone: true, showEmail: true } as CustomerInfoBlockSettings },
        { id: 'b-tbl', type: 'itemsTable', visible: true, order: 2, settings: { zebraStripes: true, showDiscount: true, showSct: false } as ItemsTableBlockSettings },
        { id: 'b-tot', type: 'totals', visible: true, order: 3, settings: { position: 'right', showDetails: true } as TotalsBlockSettings },
        { id: 'b-trm', type: 'terms', visible: true, order: 4, settings: { borderStyle: 'left-accent' } as TermsBlockSettings },
        { id: 'b-sig', type: 'signature', visible: true, order: 5, settings: { name: 'Genel Müdür', title: '' } as SignatureBlockSettings },
        { id: 'b-ftr', type: 'footer', visible: true, order: 6, settings: { showMersis: true, showTradeRegistry: true, showContact: true } as FooterBlockSettings },
      ],
    },
  ],
};

// ============================================================================
// MODERN PRESET (kapak + teklif, sade)
// ============================================================================

const MODERN_LAYOUT: TemplateLayoutConfig = {
  pages: [
    {
      id: 'p-cover', type: 'coverPage', visible: true, order: 0, title: 'Kapak',
      settings: { titleText: 'Teklif', subtitleText: '', showDecorCircles: true, bgGradient: true, preparedBy: {} } as CoverPageSettings,
    },
    {
      id: 'p-offer', type: 'offerPage', visible: true, order: 1, title: 'Teklif',
      settings: { showGreeting: true } as OfferPageSettings,
      blocks: [
        { id: 'b-greet', type: 'greeting', visible: true, order: 0, settings: { text: 'Fiyat teklifimizi bilgilerinize sunarız.', showDate: true } as GreetingBlockSettings },
        { id: 'b-cust', type: 'customerInfo', visible: true, order: 1, settings: { borderStyle: 'left-accent', showTaxInfo: true, showAddress: true, showPhone: true, showEmail: true } as CustomerInfoBlockSettings },
        { id: 'b-tbl', type: 'itemsTable', visible: true, order: 2, settings: { zebraStripes: true, showDiscount: true } as ItemsTableBlockSettings },
        { id: 'b-tot', type: 'totals', visible: true, order: 3, settings: { position: 'right', showDetails: true } as TotalsBlockSettings },
        { id: 'b-trm', type: 'terms', visible: true, order: 4, settings: { borderStyle: 'left-accent' } as TermsBlockSettings },
        { id: 'b-bank', type: 'bankAccounts', visible: true, order: 5, settings: { showHeader: true } as BankAccountsBlockSettings },
        { id: 'b-ftr', type: 'footer', visible: true, order: 6, settings: { showMersis: true, showTradeRegistry: true, showContact: true } as FooterBlockSettings },
      ],
    },
  ],
};

// ============================================================================
// MİNİMALİST PRESET (sadece teklif sayfası, kapak yok)
// ============================================================================

const MINIMALIST_LAYOUT: TemplateLayoutConfig = {
  pages: [
    {
      id: 'p-offer', type: 'offerPage', visible: true, order: 0, title: 'Teklif',
      settings: { showGreeting: true } as OfferPageSettings,
      blocks: [
        { id: 'b-greet', type: 'greeting', visible: true, order: 0, settings: { text: 'Teklifimizi bilgilerinize sunarız.', showDate: true } as GreetingBlockSettings },
        { id: 'b-cust', type: 'customerInfo', visible: true, order: 1, settings: { borderStyle: 'none', showTaxInfo: true, showAddress: true } as CustomerInfoBlockSettings },
        { id: 'b-tbl', type: 'itemsTable', visible: true, order: 2, settings: { zebraStripes: false, showDiscount: true } as ItemsTableBlockSettings },
        { id: 'b-tot', type: 'totals', visible: true, order: 3, settings: { position: 'right' } as TotalsBlockSettings },
        { id: 'b-trm', type: 'terms', visible: true, order: 4, settings: { borderStyle: 'none' } as TermsBlockSettings },
        { id: 'b-ftr', type: 'footer', visible: true, order: 5, settings: { showContact: true } as FooterBlockSettings },
      ],
    },
  ],
};

// ============================================================================
// DETAYLI PRESET (kapak + tanıtım + misyon + hizmetler + çözümler + teklif + banka)
// ============================================================================

const DETAYLI_LAYOUT: TemplateLayoutConfig = {
  pages: [
    ...KURUMSAL_LAYOUT.pages.slice(0, 4),
    {
      id: 'p-mission', type: 'contentPage', visible: true, order: 4, title: 'Misyonumuz',
      settings: { bgColor: '#ffffff' } as ContentPageSettings,
      blocks: [
        { id: 'b-q2', type: 'quote', visible: true, order: 0, settings: { text: 'İş dünyasında olumlu bir etki yaratmak istiyoruz.', fontSize: 20 } as QuoteBlockSettings },
        { id: 'b-h4', type: 'heading', visible: true, order: 1, settings: { text: 'Misyonumuz', fontSize: 28, align: 'left' } as HeadingBlockSettings },
        { id: 'b-p3', type: 'paragraph', visible: true, order: 2, settings: { text: 'Sektörümüzde güvenilir, yenilikçi ve sürdürülebilir çözümler üreterek müşterilerimize en yüksek katma değeri sağlayan, değişime hızla uyum sağlayan ve sektörde öncü konumunu koruyan bir şirket olmak.', fontSize: 14, align: 'left' } as ParagraphBlockSettings },
      ],
    },
    {
      id: 'p-solutions', type: 'contentPage', visible: true, order: 5, title: 'Çözümlerimiz',
      settings: { bgColor: '#ffffff' } as ContentPageSettings,
      blocks: [
        { id: 'b-h5', type: 'heading', visible: true, order: 0, settings: { text: 'Çözümlerimiz', fontSize: 28, align: 'left' } as HeadingBlockSettings },
        { id: 'b-p4', type: 'paragraph', visible: true, order: 1, settings: { text: 'Geniş kapsamlı teknoloji çözümleri sunmaktayız. İşletmelerin verimliliğini artıran yenilikçi teknolojiler geliştirmekte ve farklı sektörlerin ihtiyaçlarına özel çözümler üretmekteyiz.', fontSize: 14, align: 'left' } as ParagraphBlockSettings },
      ],
    },
    {
      ...KURUMSAL_LAYOUT.pages[4],
      order: 6,
    },
  ],
};

// ============================================================================
// PRESET LİSTESİ
// ============================================================================

export const TEMPLATE_PRESETS: TemplatePreset[] = [
  {
    id: 'kurumsal',
    name: 'Kurumsal',
    description: 'Kapak + Firma tanıtımı + Teklif (SIBLY Hotel benzeri profesyonel döküman)',
    config: { anaRenk: '#1a3a7a', aksanRenk: '#4a90d9', font: 'Arial', fontBoyutu: 13 },
    layout: KURUMSAL_LAYOUT,
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Kapak + Teklif sayfası, sade ve şık',
    config: { anaRenk: '#2d3436', aksanRenk: '#00b894', font: 'Segoe UI', fontBoyutu: 13 },
    layout: MODERN_LAYOUT,
  },
  {
    id: 'minimalist',
    name: 'Minimalist',
    description: 'Sadece teklif sayfası, kapak yok, temiz görünüm',
    config: { anaRenk: '#333333', aksanRenk: '#666666', font: 'Helvetica', fontBoyutu: 13 },
    layout: MINIMALIST_LAYOUT,
  },
  {
    id: 'detayli',
    name: 'Detaylı',
    description: 'Kapak + Giriş + Hakkımızda + Misyon + Hizmetler + Çözümler + Teklif',
    config: { anaRenk: '#1a3a7a', aksanRenk: '#e74c3c', font: 'Georgia', fontBoyutu: 13 },
    layout: DETAYLI_LAYOUT,
  },
];
